import { Wrapper } from './index.styles';

import Content from './content';
import Nav from './nav';
import UrgentMessagesMonitor from './urgent_messages_monitor';
import WebsocketHandler from './websocket_handler';
import YourCodeDialog from './your_code_dialog';

export default function IndexPage() {
  return (
    <Wrapper>
      <Nav />
      <Content />
      <YourCodeDialog />
      <WebsocketHandler />
      <UrgentMessagesMonitor />
    </Wrapper>
  );
}
